import gql from 'graphql-tag';

export const NAME = 'compositions_CaseRestoreButton_restoreCaseMutation';

const query = gql`
  mutation ${NAME} ($caseId: ID!) {
    restoreCanceledCase(input: { id: $caseId }) {
      case {
        id
        status
        statusHistory {
          id
          changedAt
          createdAt
          newStatus
          oldStatus
          user { email name }
        }
      }
    }
  }
`;

export default query;



// WEBPACK FOOTER //
// ./src/compositions/CaseStatus/CasePanelStatuses/CaseRestoreButton/withRestoreCase/restoreCaseMutation.js